let options = {
  storeIdentifier: "",
  environment: "prod"
};
function setOptions(opts) {
  options = opts;
}
function getOptions() {
  return options;
}
export { getOptions, setOptions };